module.exports = __webpack_public_path__ + "static/media/products_active.e661d3c2.svg";